export default {
  email: {
    presence: { allowEmpty: false },
    email: true,
    length: {
      maximum: 64
    }
  }
};
